// UWAGA: Wykorzystane w OPAC
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  get checkboxTargets () {
    return this.element.querySelectorAll('input[type="checkbox"]')
  }

  clearAll () {
    this.element.dataset.blockSubmit = true
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
      checkbox.dispatchEvent(new Event('change'))
    })
    this.element.dataset.blockSubmit = false
  }

  selectAll () {
    this.element.dataset.blockSubmit = true
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = true
      checkbox.dispatchEvent(new Event('change'))
    })
    this.element.dataset.blockSubmit = false
  }
}
